---
title: The Vault
lede: Logins a workspace remembers, so a session's browser can get past a sign-in page.
order: 42
part: Shape the machine
---

The Vault keeps the logins for the pages your sessions serve, so you can sign a page in without retyping the password. Open it with `⌘⌥3`, or the **Vault** icon at the foot of the navigator.

![The Vault](media/vault-pane.webp)

### What it holds

**Origins** on the left lists every address a login is kept for; the login itself is on the right. Entries belong to the workspace, not to a session: a login is offered in every session of that workspace and outlives the session that saved it.

Passwords are kept in the OS keychain and never shown again. Picking an entry leaves the field empty; typing a new password replaces it.

### Save a login

From a session's [browser](/browser): sign the page in once, and a bar asks **Remember** that login for that address. **Save** keeps it, **Not now** does not.

By hand, in the Vault:

1. Click **+** (**Add a login**).
2. Fill in **Origin** (the address the session serves the page on, such as `http://localhost:3000`), **Username** (optional) and **Password**.
3. Click **Save**.

**Forget** removes an entry, after asking.

### Fill a login

In a session's browser, click the key at the end of the address field, **Logins for this page**. It lists this workspace's logins for that address; **Fill** types one into the page's form. **Add a login** and the bin beside each row save and forget from there too.

The password is typed by Airlock from outside the sandbox and is **never written into the sandbox**. An agent with [Agent MCP](/agent-preview) can ask Airlock to fill a login the same way, and sees the signed-in page with the password field masked, never the password.

![Logins for this page](media/vault-browser-logins.webp)
